import { Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import SurveyModule from './survey';
import SessionModule from './session';
import { Settings } from '~/services/settings';
import { EligibilityQuestions } from '~/types/eligibility';

@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public survey!: SurveyModule;

    @Resolve
    public session!: SessionModule;

    public sppEligibilityData: EligibilityQuestions = {};
    public hubEligibilityData: EligibilityQuestions = {};

    public isEligible = false;

    @Mutation
    public async updateSppEligibilityData(newEligibilityData: EligibilityQuestions) {
        this.sppEligibilityData = { ...this.sppEligibilityData, ...newEligibilityData };
    }
    @Mutation
    public async updateHubEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.hubEligibilityData) {
        this.hubEligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Mutation
    public resetEligibilityQuestions() {
        this.sppEligibilityData = {};
    }
}
